import React, {useEffect} from "react";
import { ScrolltoTop } from "../Utility";
const Terms = () => {

  useEffect(() => {
    ScrolltoTop()
}, [])

  return (
    <>
      <section className="">
        <div className="relative flex flex-col justify-center rounded-lg items-center mt-6 md:mt-3 mx-3 md:mx-auto bg-[#EDF6EA] md:w-[98%] h-44 md:h-80">
          <img
            className=" absolute  -left-3 -top-3 rotate-180 max-md:hidden  "
            src="assets/images/groupleaf.png" alt=""
          ></img>
          <h1 className="text-3xl md:text-5xl lg:text-6xl xl:text-7xl text-primary font-semibold md:font-bold ">
            Terms & Conditions
          </h1>
          <hr className="max-md:hidden  w-60 border-primary mt-4" />
          <p className=" lg:text-2xl  font-bold  max-md:hidden mt-3   ">
            HOME / Terms & Conditions
          </p>
          <img
            className="absolute -right-3 -bottom-3   max-md:hidden "
            src="assets/images/groupleaf.png" alt=""
          ></img>
        </div>

        <div className="px-6 md:px-12 xl:text-lg  lg:text-md  text-justify  my-8 md:my-16  font-AVENIR font-medium space-y-4  md:mx-10 ">
          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary font-AVENIR pb-4">
            Welcome to Keerai Kadai!
          </h1>
         
            <p>
              These terms and conditions outline the rules and regulations for
              the use of Keerai Kadai Ventures Private Limited’s Website,
              located at
           www.keeraikadai.com.
          </p>

          
            <p>
              By accessing this website, we assume you accept these terms and
              conditions. Do not continue to use Keerai Kadai if you do not
              agree
           to take all of the terms and conditions stated on this page.
          </p>

            <p>
              The following terminology applies to these Terms and Conditions,
              Privacy Statement and Disclaimer Notice and all Agreements:
           
              “Client”, “You” and “Your” refers to you, the person logged onto
              this website and compliant to the Company’s terms and conditions.
            
              “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our
              Company. “Party”, “Parties”, or “Us”, refers to both the Client
              and
           
              ourselves. All terms refer to the offer, acceptance and
              consideration of payment necessary to undertake the process of our
              assistance to
           
              the Client in the most appropriate manner for the express purpose
              of meeting the Client’s needs in respect of provision of the{" "}
           
              Company’s stated services, in accordance with and subject to,
              prevailing law of India. Any use of the above terminology or other
              words
            in the singular, plural, capitalization and/or he/she or they, are
            taken as interchangeable and therefore as referring to same.
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-5">
            Cookies
          </h1>
         
            <p>
              We employ the use of cookies. By accessing Keerai Kadai, you
              agreed to use cookies in agreement with the Keerai Kadai Ventures
             Private Limited’s Privacy Policy.
          </p>

            <p>
              Most interactive websites use cookies to let us retrieve the
              user’s details for each visit. Cookies are used by our website to
              enable the{" "}
           
              functionality of certain areas to make it easier for people
              visiting our website. Some of our affiliate/advertising partners
              may also use
           
            cookies.
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-5">
            License
          </h1>
         
            <p>
              Unless otherwise stated, Keerai Kadai Ventures Private Limited
              and/or its licensors own the intellectual property rights for all
              material on
           
              Keerai Kadai. All intellectual property rights are reserved. You
              may access this from Keerai Kadai for your own personal use
              subjected to
            
            restrictions set in these terms and conditions.
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-5">
            You must not:
          </h1>
          <div className="flex  gap-1">
            <img src="assets/images/termsarrow.png" className="lg:w-7 h-7 sm:w-3" alt="" />
            <p>Republish material from Keerai Kadai</p>
          </div>
          <div className="flex  gap-1">
            <img src="assets/images/termsarrow.png" className="lg:w-7 h-7 sm:w-3 "  alt="" />
            <p>Sell, rent or sub-license material from Keerai Kadai</p>
          </div>
          <div className="flex gap-1">
            <img src="assets/images/termsarrow.png" className="lg:w-7 h-7 sm:w-3 "  alt="" />
            <p>Reproduce, duplicate or copy material from Keerai Kada</p>
          </div>
          <div className="flex gap-1">
            <img src="assets/images/termsarrow.png" className="lg:w-7 h-7 sm:w-3"  alt="" />
            <p>Redistribute content from Keerai Kadai</p>
          </div>

         
            <p>
              This Agreement shall begin on the date hereof. Our Terms and
              Conditions were created with the help of the Terms and Conditions
           
            Generator.
          </p>

        
            <p>
              Parts of this website offer an opportunity for users to post and
              exchange opinions and information in certain areas of the website.
           
              Keerai Kadai Ventures Private Limited does not filter, edit,
              publish or review Comments prior to their presence on the website.
            
              
              Comments do not reflect the views and opinions of Keerai Kadai
              Ventures Private Limited, its agents and/or affiliates. Comments
              reflect
           
              the views and opinions of the person who post their views and
              opinions. To the extent permitted by applicable laws, Keerai Kadai
           
             
              Ventures Private Limited shall not be liable for the Comments or
              for any liability, damages or expenses caused and/or suffered as a{" "}
            
              result of any use of and/or posting of and/or appearance of the
              Comments on this website.
            </p>
         

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-4   ">
            You warrant and represent that:
          </h1>

          <p>
            You are entitled to post the Comments on our website and have all
            necessary licenses and consents to do so.
          </p>

         
            <p>
              
              The Comments do not invade any intellectual property right,
              including without limitation copyright, patent or trademark of any
              third
           
            party.
          </p>

          <p>
            The Comments do not contain any defamatory, libellous, offensive,
            indecent or otherwise unlawful material which is an invasion of
            privacy.
          </p>

          <p>
            The Comments will not be used to solicit or promote business or
            custom or present commercial activities or unlawful activity.
          </p>

         
            <p>
              You hereby grant Keerai Kadai Ventures Private Limited a
              non-exclusive license to use, reproduce, edit and authorize others
              to use,
           
            reproduce and edit any of your Comments in any and all forms,
            formats or media.
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-5">
            Hyperlinking to our Content
          </h1>
          <p>
            The following organizations may link to our Website without prior
            written approval:
          </p>

          <p>Government agencies;</p>

          <p>Search engines;</p>

          <p>News organizations;</p>

         
            <p>
              Online directory distributors may link to our Website in the same
              manner as they hyperlink to the Websites of other listed
              businesses;
           
              and System wide Accredited Businesses exceptsoliciting non-profit
              organizations, charity, shopping malls, and charity fundraising
            
            groups which may not hyperlink to our Website.
          </p>

          
            <p>
              These organizations may link to our home page, to publications or
              to other Website information so long as the link: (a) is not in
              any way
           
              deceptive; (b) does not falsely imply sponsorship, endorsement or
              approval of the linking party and its products and/or services;
              and (c)
            
            fits within the context of the linking party’s site.
          </p>

          <p>
            We may consider and approve other link requests from the following
            types of organizations:
          </p>

          <p>commonly-known consumer and/or business information sources;</p>

          <p>dot.com community sites;</p>

          <p>associations or other groups representing charities;</p>

          <p>online directory distributors;</p>

          <p>internet portals;</p>

          <p>accounting, law and consulting firms; and</p>

          <p>educational institutions and trade associations.</p>

         
            <p>
              We will approve link requests from these organizations if we
              decide that: (a) the link would not make us look unfavourably to
              ourselves{" "}
           
              or to our accredited businesses; (b) the organization does not
              have any negative records with us; (c) the benefit to us from the
              visibility
          
              of the hyperlink compensates the absence of Keerai Kadai Ventures
              Private Limited; and (d) the link is in the context of general
              resource
            
            information.
          </p>

          
            <p>
              These organizations may link to our home page so long as the link:
              (a) is not in any way deceptive; (b) does not falsely imply{" "}
           
              sponsorship, endorsement or approval of the linking party and its
              products or services; and (c) fits within the context of the
              linking{" "}
            
            party’s site.
          </p>

         
            <p>
              If you are one of the organizations listed in paragraph 2 above
              and are interested in linking to our website, you must inform us
              by
          
              sending an e-mail to Keerai Kadai Ventures Private Limited. Please
              include your name, your organization name, contact information as{" "}
           
            well as
          

         
            
              the URL of your site, a list of any URLs from which you intend to
              link to our website, and a list of the URLs on our site to which
              you
           
            would like to link. Wait 2-3 weeks for a response.
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-5">
            Approved organizations may hyperlink to our Website as follows:
          </h1>
          <p>By use of our corporate name; or</p>

          <p>By use of the uniform resource locator being linked to; or</p>

         
            <p>
              By use of any other description of our Website being linked to
              that makes sense within the context and format of content on the
              linking
            
            party’s site.
          </p>

         
            <p>
              No use of Keerai Kadai Ventures Private Limited’s logo or other
              artwork will be allowed for linking absent a trademark license
            
            agreement.
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-4">
            iFrames
          </h1>
         
            <p>
              Without prior approval and written permission, you may not create
              frames around our Webpages that alter in any way the visual{" "}
           
            presentation or appearance of our Website.
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-4 ">
            Content Liability
          </h1>
        
            <p>
              We shall not be held responsible for any content that appears on
              your Website. You agree to protect and defend us against all
              claims

              that is rising on your Website. No link(s) should appear on any
              Website that may be interpreted as libellous, obscene or criminal,
              or
            
            which infringes, otherwise violates, or advocates the infringement
            or other violation of, any third party rights.
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-4 ">
            Your Privacy
          </h1>
          <p>
            Please read <span className="underline">Privacy Policy</span>
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-4 ">
            Reservation of Rights
          </h1>
         
            <p>
              We reserve the right to request that you remove all links or any
              particular link to our Website. You approve to immediately remove
              all
              
              links to our Website upon request. We also reserve the right to
              amend these terms and conditions and it’s linking policy at any
              time. By
           
            continuously linking to our Website, you agree to be bound to and
            follow these linking terms and conditions.
          </p>

          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary py-4">
            Removal of links from our website
          </h1>
          
            <p>
              If you find any link on our Website that is offensive for any
              reason, you are free to contact and inform us any moment. We will
              consider
            
            requests to remove links but we are not obligated to or so or to
            respond to you directly.
          </p>

         
            <p>
              We do not ensure that the information on this website is correct,
              we do not warrant its completeness or accuracy; nor do we promise
              to
            
            ensure that the website remains available or that the material on
            the website is kept up to date.
            </p>
           
          <h1 className="font-semibold md:font-medium text-2xl md:text-3xl  text-primary ">
            Disclaimer
          </h1>
         
            <p>
              To the maximum extent permitted by applicable law, we exclude all
              representations, warranties and conditions relating to our website
           
            and the use of this website. Nothing in this disclaimer will:
          </p>

          <p>
            limit or exclude our or your liability for death or personal injury;
          </p>

          <p>
            limit or exclude our or your liability for fraud or fraudulent
            misrepresentation;
          </p>

          <p className="">
            <p>
              limit any of our or your liabilities in any way that is not
              permitted under applicable law; or
            </p>
            exclude any of our or your liabilities that may not be excluded
            under applicable law.
          </p>

         
            <p>
              The limitations and prohibitions of liability set in this Section
              and elsewhere in this disclaimer: (a) are subject to the preceding
           
              paragraph; and (b) govern all liabilities arising under the
              disclaimer, including liabilities arising in contract, in tort and
              for breach of
            </p>
            statutory duty.
          

         
            <p>
              As long as the website and the information and services on the
              website are provided free of charge, we will not be liable for any
              loss or{" "}
            </p>
            damage of any nature.
          
        </div>
      </section>
    </>
  );
};

export default Terms;
